import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Popover, Modal, ModalHeader, ModalFooter, ModalBody, Row, Col, FormGroup, Input, Label, Progress, InputGroup, Alert } from 'reactstrap';
import Dropzone from 'react-dropzone';
import CloudUpload from '@mui/icons-material/CloudUploadOutlined'
import CloudDone from '@mui/icons-material/CloudDoneOutlined'
import Error from '@mui/icons-material/ErrorOutline'

class CertificatesUploadModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            runActions: false,
            selectedDocuments: [],
            dropComplete: false,
            uploadError: false,
            dropMessage: ''
        };
    }

    onDragEnter = () => {
        this.setState({
            dropzoneActive: true
        });
    }

    onDragLeave = () => {
        this.setState({
            dropzoneActive: false
        });
    }

    onDrop = (files) => {
        this.setState({
            selectedDocuments: files,
            // selectedFileName: files[0].name,
            dropComplete: true
        });
    }

    runActionsCheckChanged = (e) => {
        const target = e.target;
        const value = target.checked;
        this.setState({
            runActions: value
        })
    }

    uploadCerts = () => {
        //apend the file and then the meta data as seperate parms

        // key: fs.readFileSync('./cert/private.key'),
        // cert: fs.readFileSync('./cert/cert.crt'),
        // ca: fs.readFileSync('./cert/bundle.crt')

        if (this.state.selectedDocuments) {
            const key = this.state.selectedDocuments.find(doc => doc.name.endsWith(".key"));
            const ca = this.state.selectedDocuments.find(doc => doc.name.toLowerCase().includes("bundle") && doc.name.endsWith(".crt"));
            const cert = this.state.selectedDocuments.find(doc => doc.name.endsWith(".crt") && doc !== ca);

            if (!key) {
                this.setState({
                    dropComplete: false,
                    uploadError: true,
                    dropMessage: "No .key file found, please add to continue"
                })
                return;
            }
            if (!cert) {
                this.setState({
                    dropComplete: false,
                    uploadError: true,
                    dropMessage: "No certificate .crt file found, please add to continue"
                })
                return;
            }
            if (!ca) {
                this.setState({
                    dropComplete: false,
                    uploadError: true,
                    dropMessage: "No bundle .crt file found, please add to continue"
                })
                return;
            }
            var data = new FormData();

            //apend the file and then the meta data as seperate parms
            data.append("key", key);
            data.append("cert", cert);
            data.append("ca", ca);

            fetch(window.location.protocol + '//' + window.location.host + "/api/configuration/upload_certs", {
                method: "POST",
                body: data
            })
                .then(res => res.json())
                .then(result => {
                    this.setState({
                        dropComplete: true,
                        uploadError: result.result == 'error',
                        dropMessage: result.message
                    })
                })
                .catch((error) => {
                    this.setState({
                        dropComplete: true,
                        uploadError: true,
                        dropMessage: error.message
                    })
                });
        }
    }

    render() {
        const { parsed, userReducer } = this.props;
        const { localisation } = userReducer;

        const overlayStyle = {
            position: 'absolute',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            padding: '100px 20px',
            textAlign: 'center',
            fontSize: '2em',
            color: '#5f6368',
            backgroundColor: this.state.dropzoneActive ? '#f5f5f5' : '#fff',
            outline: '2px dashed #5f6368',
            outlineOffset: '-10px'
        };

        return (
            <Modal isOpen={this.props.visible} toggle={this.props.toggle} className='modal-dialog'>
                <ModalHeader toggle={this.props.toggle}>{localisation['doc_type_validation_header'] ? localisation['doc_type_validation_header'].element_lang : 'Drop certificates for server'}</ModalHeader>
                <ModalBody>
                    <Dropzone
                        style={{ position: "relative", width: 800, height: 400 }}
                        accept=".key,.crt"
                        onDrop={this.onDrop}
                        onDragEnter={this.onDragEnter}
                        onDragLeave={this.onDragLeave}
                    >
                        {this.state.dropComplete ?
                            <>
                                <div style={overlayStyle}>
                                    {this.state.selectedDocuments.map(document => (
                                        <p><strong>{document.name}</strong> added.</p>
                                    ))}
                                </div>
                            </>
                            :
                            <>
                                <div style={overlayStyle}>
                                    <CloudUpload fontSize={'inherit'} style={{ fontSize: '4rem' }} />
                                    <p><strong>Choose a file</strong> or drag it here.</p>
                                    <p>Please drop: a .key file + a bundle .crt file + a certificate .crt file</p>
                                </div>
                            </>
                        }
                    </Dropzone>
                    {this.state.dropMessage &&
                        <Alert color={this.state.uploadError ? "danger" : "success"}>{this.state.dropMessage}</Alert>
                    }
                    <ModalFooter>
                        <Button color="success" onClick={this.uploadCerts}>{localisation['upload_button'] ? localisation['upload_button'].element_lang : 'Upload'}</Button>
                        <Button color="secondary" onClick={this.props.toggle}>{localisation['close_button'] ? localisation['close_button'].element_lang : ''}</Button>
                    </ModalFooter>
                </ModalBody>
            </Modal>
        );
    }
}
export default connect(state => state)(CertificatesUploadModal);
